module.exports = __webpack_public_path__ + "media/images/footer/en_efs-4f2d8421000a9e9a7b91ec6ee2a1d66b.svg";